import axios from "axios";
import {BASE_URL} from "../utiles/constant";
export  const SubTopic ={
  subTopic : "/api/subTopic", 
}
const user =  localStorage.getItem('user')
const token  = JSON.parse(user);

export  const editSubTopic = (data) => {
    return axios.put(`${BASE_URL}${SubTopic.subTopic}/${data.id}`,data,
    { headers: {"Authorization" : `Bearer ${token.token}`} }
    
    ).then(res=>{
      //  console.log(res,'TEST')
    }).catch(err=>{
     //   console.log(err)
    })
  };


  export  const deleteSubTopic = (del) => {
    return axios.delete(`${BASE_URL}${SubTopic.subTopic}/${del.id}`,
    { headers: {"Authorization" : `Bearer ${token.token}`} }
    
    ).then(res=>{
     //   console.log(res,'TEST')
    }).catch(err=>{
      //  console.log(err)
    })
  };

export  const createSubTopic = (data) => {
    return axios.post(`${BASE_URL}${SubTopic.subTopic}`,data,
    { headers: {"Authorization" : `Bearer ${token.token}`} }
    
    ).then(res=>{
        console.log(res,'TEST')
    }).catch(err=>{
     //   console.log(err)
    })
  };


